<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="600"
    @click:outside="onClose"
    @keydown.esc="onClose"
  >
    <v-card>
      <v-card-title>Импорт слоя</v-card-title>

      <v-card-text>
        <v-container>
          <h4>Выберите файл для импорта</h4>
          <v-file-input
            label="Выберите файл"
            accept="application/json"
            @change="onImportFile($event)"
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          color="blue darken-1"
          text
          @click="onClose"
        >
          Отмена
        </v-btn>

        <v-btn
          color="success darken-1"
          text
          :disabled="!isValidData"
          @click="addImportFile"
        >
          Выполнить импорт
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'import-sync-dialog',

  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isValidData: false,
    importFile: null,
  }),

  beforeDestroy() {
    this.isValidData = false;
    this.importFile = null;
  },

  methods: {
    ...mapActions(['showNotify']),

    showError() {
      const errorMessage = 'Неверный формат данных. Проверьте файл.';
      this.showNotify({ type: 'error', message: errorMessage });
    },

    async onImportFile(file) {
      try {
        if (!file) {
          this.isValidData = false;
          return;
        }

        if (file.type === 'application/json') {
          this.importFile = new FormData();
          this.importFile.set('file', file);
          this.isValidData = true;
        } else {
          this.showError();
        }
      } catch (error) {
        this.showError();
        console.error(error);
        this.isValidData = false;
      }
    },

    addImportFile() {
      this.$emit('add-import-file', this.importFile);
    },

    onClose() {
      this.$emit('closed');
    },
  },
};
</script>
